export const keywordsKeys = {
  all: (...args) => ["keywords", ...args]
};
